import WebGLOverlay from './WebGLOverlay';

const overlay = {
  ref: null,

  init() {
    overlay.ref = new WebGLOverlay(
      document.querySelector('[data-webgl-canvas]'),
      document.querySelector('[data-webgl-container]'),
    );
  },
};

export default overlay;
